export default "__VITE_ASSET__BiaCN_89__"